import { UserAuditReports } from '@/features/user-audit/user-audit-reports';
import { UserAuditSection } from '@/features/user-audit/user-audit-section';

const UserAuditPage = () => (
  <UserAuditSection>
    <UserAuditReports />
  </UserAuditSection>
);
UserAuditPage.displayName = 'UserAuditPage';

export default UserAuditPage;
